import gql from 'graphql-tag';

export const removeParticipantMutation = gql`
  mutation RemoveParticipant($id: ID!) {
    removeParticipant(id: $id)
  }
`;